import { EVENT_NAMES, EVENT_CATEGORIES, HIT_TYPE } from 'app-webtech-core/beacon/const';
import { getCmFields } from './helpers/getCmFields';

/**
 * Fired at the when the user stop watching an Ad.
 * Can be because the Ad finished or because the user changed channel
 */

// eslint-disable-next-line no-unused-vars
export const cmEndBeacon = (action, prevState, nextState) => {
  const { adBreakDuration, ad, adIndex } = action.payload;
  const cmFields = getCmFields({ adBreakDuration, ad, adIndex });
  return {
    hitType: HIT_TYPE.EVENT,
    eventCategory: EVENT_CATEGORIES.CM,
    eventName: EVENT_NAMES.CM_END,
    ...cmFields,
  };
};
